import Button from '../common/components/Button';
import { useDesktop } from '../common/components/DesktopContext';
import Icon from '../common/components/Icon';
import { useProcedures } from '../reducers/procedureSlice';
import PropTypes from 'prop-types';
import { useCADPopout } from '../utils/CADStateProvider';
import { useSpecializedTranslation } from '../hooks/specializedTranslationHook';
import { useJob } from '../reducers/jobSlice';

const JobSOPButton = ({ jobid }) => {
    const desktop = useDesktop();
    const popout = useCADPopout();
    const job = useJob(jobid);
    const { t } = useSpecializedTranslation(job);

    const procedures = useProcedures(job?.site, job?.level, job?.type, job?.problem, job?.priority);

    const handleClick = () => {
        if (desktop) {
            desktop.setComponent({ component: 'jobProcedurePanel' });
        } else if (popout) {
            popout('jobProcedurePanel');
        }
    }

    if (jobid && procedures?.length > 0 && (desktop || popout)) {
        return <Button variant="success" layout="stacked" onClick={handleClick}><Icon variant="solid" kind="list-check"></Icon> {t('sop', { count: 1 })}</Button>
    }
}

JobSOPButton.propTypes = {
    jobid: PropTypes.string
}

export default JobSOPButton;